export default function ConnectivityIssue() {

  return (
    <>
      {/* <div className="flex flex-col items-center justify-around m-auto p-8 h-dvh">
        <div >
          <img src={`${process.env.REACT_APP_CDN}/404-marketplace.svg`} alt="not found" />
        </div>
        <div className="font-mRegular text-xl mt-8">The chatbot is currently inactive. For more information or assistance, please reach out to the chatbot provider.</div>
      </div> */}
    </>
  );
}